import * as d3 from 'd3'
export default {
  methods: {

    draw_Database() {

      this.databaseCanvas = this.canvasForms
      .append('g')
      .attr('transform', `translate(30, 120)`)

      let x_ = 0
      this.phase.list.filter(f=> f.code).forEach(ph=> {

        let phaseGroup = this.databaseCanvas
        .append('g')
        .attr('transform', `translate(${x_}, 0)`)
        .attr('opacity', 1)
        .call(this.gmx_openWindow, {exeFunc: this.dia_Router, width: 900, height: 720, mode: 'new', phase: ph.code,}) // -----> dia_Router.js

        phaseGroup
        .append('rect')
        .attr('x', 0).attr('y', 0)
        .attr('width', this.phase.width).attr('height', 30).attr('rx', 3).attr('ry', 3)
        .attr('fill', `url(#${this.localId}_SkyBlue_H2)`).attr('stroke', '#757575').attr('stroke-width', .5).attr('opacity', .5)

        phaseGroup
        .append('text')
        .attr('x', this.phase.width/2).attr('y', 20.5).attr('fill', '#000').attr('font-size', 15).attr('text-anchor', 'middle')
        .text(ph.code)

        ph.x = x_
        this.draw_DiagramList(ph) // -----> below
        x_ += (this.phase.width + this.phase.gap)
      })

    },


    draw_DiagramList(phase) {

      let this_ = this
      let diaGroup = this.databaseCanvas
      .append('g')
      .attr('id', `PHASE_${phase.code}`)
      .attr('transform', `translate(${phase.x}, ${60})`)

      this.db_Diagram = this.db_Diagram.sort((a, b) => a.SN - b.SN)

      let y_ = 0
      this.db_Diagram.filter(f=> f.PHASE == phase.code).forEach(d=> {
        let isClicked = false
        let dia = diaGroup
        .append('g')
        .attr('id', `DIA_LIST_GROUP_${d.IDX}`)
        .attr('transform', `translate(0, ${y_})`).attr('cursor', 'pointer').attr('opacity', 1)
        .on('mouseover', function() {
          d3.select(this).transition().duration(75).attr('opacity', .5)
          d3.select(`#ADDRESS`).transition().duration(200).attr('opacity', 1)
          d3.select(`#TITLE_PHASE`).text(d.PHASE)
          d3.select(`#TITLE_DIAGRAM`).text(d.DIAGRAM)
          d3.select(`#TITLE_DESC`).attr('x', this_.getNode(`#TITLE_DIAGRAM`)+7).text(d.DESCR)
        })
        .on('mouseout', function() {
          if (isClicked) return
          d3.select(this).transition().duration(200).attr('opacity', 1)
          d3.select(`#ADDRESS`).transition().duration(200).attr('opacity', 0)
        })
        .on('click', () => {
          isClicked = true
          this.draw_Diagram(d.IDX) // -----> draw_Diagram.js
          d3.select(`#DIA_LIST_GROUP_${d.IDX}`).attr('opacity', 1)
          d3.select(`#CANVAS_DIAGRAM`).transition().duration(300).attr('opacity', 1)
          setTimeout(() => { isClicked = false }, 300)
        })

        dia
        .append('rect')
        .attr('id', `DIA_LIST_BOX_${d.IDX}`)
        .attr('x', 0).attr('y', -10)
        .attr('width', this.phase.width).attr('height', 70).attr('rx', 3).attr('ry', 3)
        .attr('fill', '#fff').attr('stroke', '#bcbcbc').attr('stroke-width', .5).attr('opacity', .5)

        dia
        .append('text')
        .attr('x', 10).attr('y', 5)
        .attr('fill', '#757575').attr('font-size', 10)
        .text(`${d.SN}`)

        dia
        .append('text')
        .attr('x', this.phase.width-7).attr('y', 5)
        .attr('fill', '#333').attr('font-size', 12).attr('text-anchor', 'end')
        .text(`${d.CTO_DATE.slice(0, 10)}`)

        dia
        .append('text')
        .attr('x', 10).attr('y', 15).attr('fill', '#757575').attr('font-size', 10)
        .text(d.MANAGER)

        dia
        .append('text')
        .attr('x', 10).attr('y', 30).attr('fill', '#000').attr('font-size', 13)
        .text(d.DIAGRAM)

        dia
        .append('text')
        .attr('id', `DIA_LIST_UPDATE_${d.IDX}`)
        .attr('x', 10).attr('y', 53).attr('fill', '#44A9DF').attr('font-size', 10)
        .text(d.UPDATED ? `Updated: ${d.UPDATED.slice(0, 10)}` : '')

        dia
        .append('text')
        .attr('id', `DIA_LIST_DAYS_${d.IDX}`)
        .attr('x', this.phase.width-7).attr('y', 53)
        .attr('fill', '#bcbcbc').attr('font-size', 18).attr('text-anchor', 'end')
        .text(0)

        // Edit Diagram
        diaGroup
        .append('image')
        .attr('xlink:href', this.HOST + `/Database/icon/Edit.svg`)
        .attr('x', 0).attr('y', y_ + 62).attr('width', 18).attr('opacity', .5)
        .call(this.gmx_openWindow, {exeFunc: this.dia_Router, width: 900, height: 720, idx: d.IDX, mode: 'update', data: d,}, 'reverse') // -----> dia_Router.js

        // Edit Stage
        diaGroup
        .append('image')
        .attr('xlink:href', this.HOST + `/Database/icon/Stage.svg`)
        .attr('x', 25).attr('y', y_ + 62).attr('width', 18).attr('opacity', .5)
        .call(this.gmx_openWindow, {exeFunc: this.stage_Router, width: 600, height: 450, idx: d.IDX, mode: 'stage', data: d,}, 'reverse') // -----> stage_Router.js
       

        // Coloring for Delayed Diagram
        let sColor = '#bcbcbc'
        let tColor = '#757575'
        let sWidth = .5
        let noOfDays = 0

        let timenow = new Date().toISOString().slice(0, 10)

        if(d.CTO_DATE && d.PREQUENCY == 'Weekly') {
          if(timenow > this.gmx_addOneWeek(d.CTO_DATE)) {
            sColor = '#EC407A'
            sWidth = 1
            tColor = '#EC407A'
          }
          noOfDays = this.gmx_dateDiff(this.gmx_addOneWeek(d.CTO_DATE), timenow)
        } else if(d.CTO_DATE && d.PREQUENCY == 'Monthly') {
          if(timenow > this.gmx_getLastSameWeekdayOfNextMonth(d.CTO_DATE)) {
            sColor = '#EC407A'
            sWidth = 1
            tColor = '#EC407A'
          }
          noOfDays = this.gmx_dateDiff(this.gmx_getLastSameWeekdayOfNextMonth(d.CTO_DATE), timenow)
        }

        d3.select(`#DIA_LIST_BOX_${d.IDX}`).attr('stroke', sColor).attr('stroke-width', sWidth)
        d3.select(`#DIA_LIST_UPDATE_${d.IDX}`).attr('fill', tColor)
        d3.select(`#DIA_LIST_DAYS_${d.IDX}`).attr('fill', this.gmx_deltaValue(noOfDays)).text(noOfDays)

        y_ += 110
      })
    },

  }
}